export default __webpack_public_path__ + "static/media/Cloudxier-MEILISA-Profile.f05bd0f3.png";